const api = "https://app.personeriabqelearning.montierp.com/api/";
const apiImage = "https://documentos2024-aoa.s3.bhs.io.cloud.ovh.net/";
//const api = "http://127.0.0.1:8000/api/";
//const apiImage = "http://127.0.0.1:8000/storage/";
export default api;
export { apiImage };